import Buttons from '@/component/popups/Buttons';
import PopupFrame from '@/component/popups/ui-1';
import imgDontLoseYourStreak from '@assets/web-v3-images/not-lowest-unique.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

export default function RedeemFailed({
	open,
	onOpenChange,
	msg = '',
	title = '',
	images,
	textBtn
}
) {
	const { t } = useTranslation()

	return (
		<PopupFrame
			open={open}
			onOpenChange={onOpenChange}
			title={title}
			classNames='sm:!max-w-[600px]'
		>
			<div className=" flex flex-col items-center justify-center">

				<div className="flex justify-center px-10 sm:px-15 md:px-30 lg:px-30 xl:px-35 pt-5">
					<img
						src={images ? images : imgDontLoseYourStreak}
						alt="turns"
						className="w-[120px] sm:w-[160px] md:w-[220px] lg:w-[220px] xl:w-[220px] h-auto"
					/>
				</div>
				<Text
					as="p"
					className="text-[#A15C07] font-medium text-[13px] sm:text-[19px] text-center pt-6 px-10 sm:px-15"
				>
					{msg}
				</Text>

				<div className="flex gap-3 justify-between pt-5 px-[20%]">
					<Buttons
						handleClick={() => onOpenChange(false)}
						textBtn={textBtn}
						classItem="!m-0"
						classItemText='text-[16px] sm:!text-[23px]'
					/>
				</div>
			</div>
		</PopupFrame>
	)
}
